import React, { useState, useEffect } from 'react';
import { useVoiceChat } from '../contexts/VoiceChatContext';
import StreamSetupModal from './StreamSetupModal';
import { SafeImage } from './SafeImage';
import { getImageUrl } from '../services/api';

interface VoiceRoomListProps {
    onRoomCreated?: () => void;
    initialRoomData?: { title: string; category: string; type: 'voice' | 'video' } | null;
}

const VoiceRoomList: React.FC<VoiceRoomListProps> = ({ onRoomCreated, initialRoomData }) => {
    const { rooms, joinRoom, createRoom } = useVoiceChat();
    const [showCreateRoomModal, setShowCreateRoomModal] = useState(false);

    useEffect(() => {
        if (initialRoomData && initialRoomData.type === 'voice') {
            createRoom(initialRoomData.title, [initialRoomData.category]);
            if (onRoomCreated) onRoomCreated();
        }
    }, [initialRoomData, createRoom, onRoomCreated]);

    return (
        <>
            <div style={{ padding: '0 20px 80px 20px' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '15px' }}>
                    <h3 style={{ margin: 0, color: '#fff' }}>Sesli Sohbet Odaları</h3>
                    <button
                        onClick={() => setShowCreateRoomModal(true)}
                        style={{ background: '#ff007f', color: '#fff', border: 'none', padding: '8px 16px', borderRadius: '20px', cursor: 'pointer' }}
                    >+ Oda Kur</button>
                </div>

                <div style={{ display: 'grid', gap: '15px' }}>
                    {rooms.map(room => (
                        <div key={room.id} style={{ background: 'rgba(255,255,255,0.05)', borderRadius: '16px', padding: '15px', border: '1px solid rgba(255,255,255,0.05)' }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '10px' }}>
                                <div style={{ fontWeight: 'bold', color: '#fff' }}>{room.title}</div>
                                <div style={{ display: 'flex', gap: '10px' }}>
                                    <span style={{ fontSize: '12px', color: '#ff007f' }}>🎙️ {room.participants.length}/{room.maxParticipants}</span>
                                    <span style={{ fontSize: '12px', color: '#4caf50' }}>👁️ {room.audienceCount}</span>
                                </div>
                            </div>
                            <div style={{ display: 'flex', gap: '5px', flexWrap: 'wrap', marginBottom: '15px' }}>
                                {room.participants.slice(0, 5).map(p => (
                                    <SafeImage key={p.id} src={p.profileImage ? getImageUrl(p.profileImage) : (p.avatar ? getImageUrl(p.avatar) : undefined)} fallbackSrc={`https://ui-avatars.com/api/?name=${p.username}&background=random`} style={{ width: '30px', height: '30px', borderRadius: '50%' }} alt={p.username} />
                                ))}
                            </div>
                            <button
                                onClick={() => joinRoom(room)}
                                style={{ width: '100%', background: 'rgba(255,255,255,0.1)', color: '#fff', padding: '8px', borderRadius: '8px', border: 'none', cursor: 'pointer' }}
                            >Katıl</button>
                        </div>
                    ))}
                </div>
            </div>

            {showCreateRoomModal && (
                <StreamSetupModal
                    isOpen={showCreateRoomModal}
                    onClose={() => setShowCreateRoomModal(false)}
                    onStartStream={(title, category) => {
                        createRoom(title, [category]);
                        setShowCreateRoomModal(false);
                        if (onRoomCreated) onRoomCreated();
                    }}
                />
            )}
        </>
    );
};

export default VoiceRoomList;

